import styled from "@emotion/styled";
import { commonColors } from "application/theme";

interface RowStyledProps {
  isUserCommitted?: boolean;
}

export const Wrapper = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const RowStyled = styled("div")<RowStyledProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  > p {
    width: 100%;
    color: ${commonColors.grey900};
    font-family: Unica77;
    font-size: 14px;
    font-style: normal;
    font-weight: ${({ isUserCommitted }) => (isUserCommitted ? 500 : 400)};
    line-height: 130%;
    letter-spacing: 0.07px;
  }

  > h3 {
    min-width: fit-content;
    color: ${({ isUserCommitted }) =>
      isUserCommitted ? commonColors.green700 : commonColors.grey900};
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
  }
`;

export const IconWrapper = styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 28px;
  min-width: 28px;
  height: 28px;
  min-height: 28px;
  border-radius: 175px;
  background: ${commonColors.blue100};

  > svg {
    width: 16px;
    height: 16px;
  }
`;
